import style from "./Flex.module.css";
import clsx from "classnames";

function FlexChild(props) {
  let isFixed = false;
  if (props.parentClass) {
    if (props.parentClass === "vertical") {
      isFixed = props.height ? true : false;
    } else if (props.parentClass === "horizontal") {
      isFixed = props.width ? true : false;
    }
  }

  return (
    <div
      ref={props.Ref}
      className={clsx(style.flexChild, { [style.fixed]: isFixed })}
      style={{
        width: props.addWidth
          ? `calc(${props.flexBasis || "100%"} + ${props.addWidth})`
          : props.width || null, // 동적으로 width를 계산
        minWidth: props.minWidth ? props.minWidth : null,
        maxWidth: props.maxWidth ? props.maxWidth : null,
        height: props.height ? props.height : null,
        maxHeight: props.maxHeight ? props.maxHeight : null,
        minHeight: props.minHeight ? props.minHeight : null,
        overflowX: props.overflowX ? props.overflowX : null,
        overflowY: props.overflowY ? props.overflowY : null,
        alignItems: props.alignItems
          ? props.alignItems
          : props.flexStart
            ? "flex-start"
            : "center",
        alignSelf: props.alignSelf ? props.alignSelf : null,
        justifySelf: props.justifySelf ? props.justifySelf : null,
        gap: props.gap ? props.gap : null,
        justifyContent: props.justifyContent ? props.justifyContent : null,
        backgroundColor: props.backgroundColor ? props.backgroundColor : null,
        backgroundImage: props.backgroundImage ? props.backgroundImage : null,
        paddingLeft: props.paddingLeft ? props.paddingLeft : null,
        paddingRight: props.paddingRight ? props.paddingRight : null,
        paddingBottom: props.paddingBottom ? props.paddingBottom : null,
        paddingTop: props.paddingTop ? props.paddingTop : null,
        padding: props.padding ? props.padding : null,
        flexWrap: props.flexWrap ? props.flexWrap : null,
        borderRadius: props.borderRadius ? props.borderRadius : null,
        borderLeft: props.borderLeft ? props.borderLeft : null,
        borderRight: props.borderRight ? props.borderRight : null,
        borderBottom: props.borderBottom ? props.borderBottom : null,
        borderTop: props.borderTop ? props.borderTop : null,
        border: props.border ? props.border : null,
        // borderTopLeftRadius: (props.borderTopLeftRadius ? props.borderTopLeftRadius : null),
        // borderTopRightRadius: (props.borderTopRightRadius ? props.borderTopRightRadius : null),
        // borderBottomLeftRadius: (props.borderBottomLeftRadius ? props.borderBottomLeftRadius : null),
        // borderBottomRightRadius: (props.borderBottomRightRadius ? props.borderBottomRightRadius : null),
        marginLeft: props.marginLeft ? props.marginLeft : null,
        marginRight: props.marginRight ? props.marginRight : null,
        marginBottom: props.marginBottom ? props.marginBottom : null,
        marginTop: props.marginTop ? props.marginTop : null,
        margin: props.margin ? props.margin : null,
        flex: props.flex ? props.flex : null,
        flexBasis: props.flexBasis ? props.flexBasis : null,
        flexGrow: props.flexGrow ? props.flexGrow : null,
        cursor: props.cursor ? props.cursor : null,
        position: props.position ? props.position : null,
        top: props.top ? props.top : null,
        zIndex: props.zIndex ? props.zIndex : null,
      }}
      onClick={props.onClick ? props.onClick : null}
    >
      {props.children}
    </div>
  );
}

export default FlexChild;
